import {
  Form,
  IFormContext,
}                                                  from 'rewire-ui';
import UdfsFilterDialogModel                       from '../schedule/UdfsFilterDialogModel';
import { RouteManagerBase, reportRouteManager }    from '../main-navigation/RouteManager';
import reportModel                                 from './ReportModel';

export class ReportSecondaryFilterDialogModel extends UdfsFilterDialogModel {
  constructor() {
    super('Secondary Filter By', 'reports');
  }

  get isInView() {
    return !!RouteManagerBase.current.viewId;
  }

  get hasPermittedFilters() {
    return reportModel.hasPermittedSecondaryFilters;
  }

  get hasFilters() {
    return reportModel.hasSecondaryFilters;
  }

  protected _createForm(): Form {
    return Form.create((_form: IFormContext) => ({}), {}, {updateOnChange: true, disableErrors: true});
  }

  protected async _preload(_filters?: any) {
    // only display those filters applicable to the current report
    this.form.fields.forEach(field => {
      const key     = field.name;
      field.visible = reportModel.permittedSecondaryFilters().includes(key);
    });
  }

  protected async _save(filters: ObjectType): Promise<boolean> {
    if (this.isInView) {
      reportRouteManager.navigateTo({reportSecondaryFilters: filters, areaId: undefined, groupId: undefined, viewId: undefined});
    } else {
      reportRouteManager.navigateTo({reportSecondaryFilters: filters});
    }
    return true;
  }

  showSecondaryFilters() {
    this.load(reportModel.secondaryFilters);
  }
}

const reportSecondaryFilterDialogModel = new ReportSecondaryFilterDialogModel();
export default reportSecondaryFilterDialogModel;
